import { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { useInterval } from 'utils/use-interval';
import { animatedThumbnailsSelector } from './selectors';

export const useThumbnailStyle = ({ videoId, isHovered, element, thumbnailUrl }) => {
  const animationStartAt = useRef();
  const [spriteStyle, setSpriteStyle] = useState();
  const spriteIndex = useRef(0);
  const animatedThumbnail = get(useSelector(animatedThumbnailsSelector), videoId);

  if (!isHovered) {
    spriteIndex.current = 0;
  }

  useInterval(
    () => {
      if (animatedThumbnail && isHovered && element) {
        const { spritesPerRow, duration, interval } = animatedThumbnail;
        const { width, height } = element.getBoundingClientRect();

        const x = -Math.floor(spriteIndex.current % spritesPerRow) * width;
        const y = -Math.floor(spriteIndex.current / spritesPerRow) * height;

        const numberOfSprites = Math.ceil(duration / (interval * 1000)) + 1;
        const cols = spritesPerRow;
        const rows = Math.ceil(numberOfSprites / spritesPerRow);

        setSpriteStyle({
          backgroundPosition: `${x}px ${y}px`,
          backgroundSize: `${cols * 100}% ${rows * 100}% `,
          backgroundImage: `url("${animatedThumbnail.sources[0]}")`,
        });

        spriteIndex.current = numberOfSprites > spriteIndex.current + 1 ? spriteIndex.current + 1 : 0;
      }
    },
    isHovered ? 200 : null
  );

  if (!isHovered) {
    animationStartAt.current = null;
  } else if (spriteStyle && !animationStartAt.current) {
    animationStartAt.current = Date.now();
  }

  const isAnimationTimedOut = isHovered && animationStartAt.current && Date.now() - animationStartAt.current > 3000;

  const thumbnailStyle =
    isHovered && !isAnimationTimedOut && spriteStyle
      ? spriteStyle
      : {
          backgroundImage: `url(${thumbnailUrl})`,
        };

  return [thumbnailStyle, isAnimationTimedOut];
};
